export enum PROMOTION_TYPE {
  'BUSINESS' = 'BUSINESS',
  'PRODUCT' = 'PRODUCT',
  'SERVICE' = 'SERVICE',
  'JOB_OFFER' = 'JOB_OFFER',
  'OPPORTUNITY' = 'OPPORTUNITY',
}

export const PROMOTION_TYPE_VALUES = Object.values(PROMOTION_TYPE);
